module.exports = __webpack_public_path__ + "static/media/Forced_Chloroform.ecc12d04.mp3";